<template>
  <generic-modal
    v-bind="$props"
    :value="value"
    confirm-text="Create Offer"
    title="Create an offer"
    persistent
    @modal-confirm="onModalConfirm"
    @modal-cancel="onModalCancel"
  >
    <div v-if="hasErrors" class="error--text">Unable to create offer. Please try again</div>
    <autocomplete-input
      v-model="newOffer.type"
      :disabled="isLoading"
      :items="getItemsForOption('offerTypes')"
      class="mt-5"
      label="Offer Type"
      menu-props="auto"
    />
    <text-input
      v-model="newOffer.name"
      :disabled="isLoading"
      :rules="rules"
      class="mt-5"
      counter
      label="Offer Name"
      maxlength="25"
    />
  </generic-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import AutocompleteInput from '@/components/forms/autocomplete-input'
import GenericModal from '@/components/modals/generic-modal'
import TextInput from '@/components/forms/text-input'

export default {
  name: 'OfferCreateModal',
  components: {
    AutocompleteInput,
    GenericModal,
    TextInput,
  },
  props: {
    hasErrors: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    newOffer: {
      name: '',
      type: '',
    },
    rules: [
      value => !!value || 'A name is required',
      value => (value && value.length >= 3) || 'Offer name must be a minimum of 3 characters',
    ],
  }),
  computed: {
    ...mapGetters('options', ['getItemsForOption']),
  },
  methods: {
    onModalConfirm() {
      if (!this.newOffer.name || !this.newOffer.type) return

      this.$emit('modal-confirm', this.newOffer)
    },
    onModalCancel() {
      this.$emit('input', false)
    },
  },
}
</script>
